var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "page-section page-section--last"
  }, [_c('div', {
    staticClass: "mb-60 mb-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h3', {
    staticClass: "text-28 text-md-20"
  }, [_vm._v("스마트전자 확산, 제조실증 기반구축")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6 order-lg-2"
  }, [_c('div', {
    staticClass: "img-wrap text-lg-right"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/about/business-img2.png",
      "alt": "이미지"
    }
  })])]), _c('div', {
    staticClass: "col-12 col-lg-6 order-lg-1"
  }, [_c('div', {
    staticClass: "text-items"
  }, [_c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("사업명")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("스마트전자 확산을 위한 제조실증 기반구축")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("사업기간")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("’21.4.1 ~ ’25.12.31 (5년)")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("지원내용")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text line-height-18"
  }, [_vm._v("제품환류(제품 스케일업, 재설계 반복지원), 소비자실증 지원")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("사업목표")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text line-height-18"
  }, [_vm._v("전자제품의 스마트화, 소량제조, 환류, 유지보수를 지원할 수 있는 집적기반구축과 맞춤형 제조실증 지원을 통해 전자기업을 육성함")])])])])])])]), _c('div', [_c('div', {
    staticClass: "mb-30 mb-md-15"
  }, [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("1 ")]), _vm._v("비전")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('p', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('span', {
    staticClass: "color-primary"
  }, [_vm._v("누구나 쉽게 혁신하자")])])])])])]), _c('div', {
    staticClass: "mb-30 mb-md-15"
  }, [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("2 ")]), _vm._v("목표")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('p', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('span', {
    staticClass: "color-primary"
  }, [_vm._v("용산 집적화를 통한 도심 전자생태계 확보")])])])])])]), _c('div', {
    staticClass: "mb-30 mb-md-15"
  }, [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("3 ")]), _vm._v("전략")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('p', [_vm._v("1. 제조, 개발자 제품의 소비 트랜드 반영")]), _c('p', [_vm._v("2. 도심내 설계, 조립, 유지보수 가능한 제조생태계 구축")]), _c('p', [_vm._v("3. 소비자 실증 및 환류가 가능한 제조기반 구축")])])])])])]), _c('div', [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("4 ")]), _vm._v("구성")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('p', [_vm._v("1. 고객반응 및 실증이 가능한 플렘폼 구축")]), _c('p', [_vm._v("2. 스마트 제품의 조립, 제조, 실증 기반")]), _c('p', [_vm._v("3. 전자개발, 제조기업을 위한 기술 집적지 구축")])])])])])])])]);
}]

export { render, staticRenderFns }